fragment OccupationFields on UserOccupationTitle {
  id
  userOccupationTitle
  _rowTimestamp
  _isUpdatable
  _isDeletable
}
